/** @format */

export enum AddressOperationType {
  FINALIZE_ADDRESSES = 'FINALIZE_ADDRESSES',
  SAVE_ADDRESS = 'SAVE_ADDRESS',
  VERIFY_AND_ADD_ADDRESS = 'VERIFY_AND_ADD_ADDRESS',
  VERIFY_CREATE_AND_ADD_ADDRESS = 'VERIFY_CREATE_AND_ADD_ADDRESS',
  VERIFY_UPDATE_AND_ADD_ADDRESS = 'VERIFY_UPDATE_AND_ADD_ADDRESS',
}
